var lib_core = require("lib-core");

var GroupSelectionInteractionModel = require("./groupSelectionInteractionModel.js");

var GroupSelectionModel = function (selectionModel, editorModel, config) {
    var self = this;

    lib_core.Model.apply(this, arguments);
    this.editorModel = editorModel;
    this.selectionModel = selectionModel;

    this.groupSelectionIM = this.value("groupSelectionIM", true);
    this.inspectorSubjects = this.set("inspectorSubjects", false);
    this.inspectorButtons = [];

    this.onInit("initialize", this.initialize);
};
lib_core.inherit(GroupSelectionModel, lib_core.Model);
lib_core.JsonParser.registerClass(GroupSelectionModel, "GroupSelectionModel");
module.exports = GroupSelectionModel;

GroupSelectionModel.prototype.initialize = function() {
    var self = this;

    var selection = this.selectionModel.selection;

    selection.onAdd("group_selection", function() {
        self.editorModel.heavyHandler.scheduleHeavy('rebuild_group_model', updateSelectionModel, self, [], self);
    });
    selection.onRemove("group_selection", function() {
        self.editorModel.heavyHandler.scheduleHeavy('rebuild_group_model', updateSelectionModel, self, [], self);
    });

    var updateSelectionModel = function() {
        if(selection.size() === 0) {
            self.inspectorSubjects.removeAll();
        } else if(selection.size() === 1) {
            var subject = selection.getOne();
            if(!self.inspectorSubjects.contains(subject)) {
                self.inspectorSubjects.removeAll();
                self.inspectorSubjects.add(selection.getOne());
            }
        } else {
            self.inspectorSubjects.removeAll();
            self.groupSelectionIM(new GroupSelectionInteractionModel(selection));
            self.inspectorSubjects.add(self.groupSelectionIM());
        }
    };

    //override selectionmodel defaults inspectorSubjects stuff
    this.selectionModel.addToInspectorSubjects = function() { return null; };
    this.selectionModel.removeFromInspectorSubjects = function() { return null; };
    this.selectionModel.getInspectorSubjects = function() { return self.getInspectorSubjects(); };
};

GroupSelectionModel.prototype.getInspectorSubjects = function() {
    return this.inspectorSubjects;
};

GroupSelectionModel.prototype.addInspectorButtons = function(buttons) {
    this.inspectorButtons = this.inspectorButtons.concat(buttons);
};
